import { Component, ElementRef, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InstructorsComposition } from '@shared/compositions';
import { isMobileView } from '@core/utils';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InstructorType, SectionType } from '@core/enums';
import { NgSelectModule } from '@ng-select/ng-select';
import { DialogRef } from '@ngneat/dialog';
import { NumberInputDirective } from '@shared/directives';
import { ButtonComponent, DropdownComponent, IconComponent, ImageSelectorComponent } from '@shared/components/ui';
import { FormErrorComponent, TimePickerInputComponent } from '@shared/components';
import { TippyModule } from '@ngneat/helipopper';

@Component({
  selector: 'app-instructor-form',
  imports: [
    IconComponent,
    ButtonComponent,
    CommonModule,
    TimePickerInputComponent,
    FormsModule,
    ReactiveFormsModule,
    DropdownComponent,
    TranslateModule,
    ImageSelectorComponent,
    FormErrorComponent,
    NgSelectModule,
    NumberInputDirective,
    TippyModule,
  ],
  templateUrl: './instructor-form.component.html',
  styleUrls: ['./instructor-form.component.scss'],
})
export class InstructorFormComponent extends InstructorsComposition implements OnInit {
  protected readonly isMobileView = isMobileView;
  protected readonly InstructorType = InstructorType;
  protected readonly SectionType = SectionType;
  private readonly _elRef = inject(ElementRef);

  constructor() {
    super();
    if (!isMobileView()) {
      this._dialogRef = inject(DialogRef);
    }
  }

  get isUpdateMode(): boolean {
    return !!(this.currentInstructor && this.currentInstructor.id && this.currentInstructor?.imageUrl);
  }

  get instructorId(): number {
    return this.currentInstructor?.id || null;
  }

  ngOnInit() {
    this._InitDataForForm();
    if (this._dialogRef && this._dialogRef.data && this._dialogRef.data.instructor) {
      this.currentInstructor = this._dialogRef.data.instructor;
    } else if (this._bottomSheet && this._bottomSheet.currentSheetData) {
      this.currentInstructor = this._bottomSheet.currentSheetData.instructor;
    }

    if (this.currentInstructor && this.currentInstructor.id) {
      this._patchFormValues(this.currentInstructor);
    }
  }

  close() {
    if (this._dialogRef) {
      this._dialogRef.close();
    } else {
      this._bottomSheet.closeAll();
    }
  }

  save(btnRef?: ButtonComponent) {
    if (this.form.invalid) {
      this.markAllInvalidControlsAndScrollToFirst(this.form, this._elRef);
      return;
    }
    this._createInstructor(this.form.value, btnRef);
  }
}
